<div onsip-grid-placement-shelf>
  <div class="first-column">
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.PARKING_LOT_NAME" | translate }}</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_NAME">{{ parkLot.name }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">
        {{ "ONSIP_I18N.PARKING_LOT_NUMBER_OF_CHANNELS" | translate }}
      </div>
      <div [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_CHANNELS_LIMIT">
        {{ parkLot.channelLimit }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_PIN" | translate }}</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_PIN">
        {{ parkLot.pin ? parkLot.pin : ("ONSIP_I18N.NONE" | translate) }}
      </div>
    </section>
  </div>
  <div class="second-column">
    <h3>{{ "ONSIP_I18N.PARKING_LOT_DESTINATION" | translate }}</h3>
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_SIP_ADDRESS">
        {{ parkLot.address.username + "@" + parkLot.address.domain }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
      @if (parkLot.extensions.length) {
      <div>
        @for (extension of parkLot.extensions; track extension) {
        <div [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_EXTENSIONS">
          {{ extension | formatExtensions }}
        </div>
        }
      </div>
      } @else { No extensions added }
    </section>
  </div>
  <div class="third-column">
    <h3>{{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_DESTINATION" | translate }}</h3>
    <section>
      <div class="mat-body-1 m-b-12">
        {{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_ADDRESS" | translate }}
      </div>
      <div [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_RETRIEVAL_ADDRESS">
        {{ parkLot.retrieverAddress.username + "@" + parkLot.retrieverAddress.domain }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
      @if(parkLot.retrieverExtensions.length) {
      <div>
        @for (retrieverExtension of parkLot.retrieverExtensions; track retrieverExtension) {
        <div [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_RETRIEVAL_EXTENSIONS">
          {{ retrieverExtension | formatExtensions }}
        </div>
        }
      </div>
      } @else { No extensions added }
    </section>
  </div>
</div>
<div class="page-view-controls">
  <button
    mat-flat-button
    color="primary"
    (click)="editPanel.emit()"
    [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_EDIT_PARKING_LOT_SETTINGS_BUTTON"
  >
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
